import { LinkChooser } from "simplydo/react/components/Choosers/LinkChooser"

export const getSimpleMenu = (chooser, setChooser) => [
  {
    name: "link",
    icon: "linkify",
    onClick: ({ commands, isActive, selectedText }) => {
      if (isActive) {
        commands.removeLink()
      } else {
        setChooser("link", !chooser.link?.open, commands.insertLink, selectedText)
      }
    },
    MenuItem: ({ RenderItem, itemProps }) => (
      <LinkChooser
        trigger={
          <div>
            <RenderItem {...itemProps} />
          </div>
        }
        isOpen={chooser.link?.open}
        shouldFix={false}
        onClose={() => setChooser("link", false)}
        hideLinkText
        onComplete={(_text, url) => {
          chooser.link.cmd({ href: url })
          setChooser("link", false)
        }}
      />
    ),
  },
]
